import { getEnvironment } from "@util/constant";
import { getEnvironmentDomain } from "@util/helpers";

type BuildURLProps = {
  /** URL to build */
  url: string;
  /** Parameters to add to the URL */
  params: URLSearchParams;
};

/**
 * Builds a URL with the given parameters and returns a URL object.
 * @param {BuildURLProps} props - The properties to build the URL.
 * @returns {URL} The built URL.
 */
export const buildURL = ({ url, params }: BuildURLProps): URL => {
  const constructedUrl = constructURL(url);

  for (const [key, value] of params.entries()) {
    constructedUrl.searchParams.set(key, value);
  }

  return constructedUrl;
};

const constructURL = (url: string): URL => {
  try {
    return new URL(url);
  } catch (error) {
    const environment = getEnvironment();
    const envDomain = getEnvironmentDomain(environment);

    return new URL(`${envDomain}${url}`);
  }
};
